export const featuredMembers = [
  {
    id: 1,
    name: '雅婷',
    age: 28,
    location: '上海',
    locationEn: 'Shanghai',
    flag: '🇨🇳',
    education: '硕士 · 金融学',
    school: '复旦大学',
    major: '金融学',
    gradYear: '2020',
    match: 96,
    height: '165cm',
    weight: '50kg',
    zodiac: '天秤座',
    job: '金融分析师',
    income: '30-50万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '热爱生活，喜欢旅行和阅读，希望找到志同道合的另一半共同成长。我相信两个人在一起最重要的是相互尊重和共同进步，学历和价值观的契合对我来说非常重要。',
    interests: ['旅行', '阅读', '瑜伽', '美食', '摄影'],
    languages: ['普通话', '英语', '粤语'],
    lookingFor: '寻找有责任心、有上进心的另一半，学历本科以上优先',
    avatar: 'https://public.readdy.ai/ai/img_res/431952ec834cc959ebfd0ba00f9a5928.jpg',
    photos: [
      'https://readdy.ai/api/search-image?query=elegant%20Chinese%20woman%20in%20cafe%20reading%20book%2C%20warm%20cozy%20atmosphere%2C%20soft%20lighting%2C%20lifestyle%20photography%2C%20age%2028%2C%20natural%20beauty&width=600&height=400&seq=mem001p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20woman%20traveling%20outdoors%20scenic%20mountain%20view%2C%20happy%20expression%2C%20casual%20style%2C%20natural%20lighting%2C%20age%2028&width=600&height=400&seq=mem001p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20woman%20cooking%20in%20modern%20kitchen%2C%20warm%20home%20atmosphere%2C%20smiling%2C%20lifestyle%20photography%2C%20age%2028&width=600&height=400&seq=mem001p3&orientation=landscape',
    ],
    credentials: [
      { type: '硕士学位证书', institution: '复旦大学', year: '2020', verified: true },
      { type: '身份证实名认证', institution: '国家公安系统', year: '2024', verified: true },
      { type: '证券从业资格证', institution: '中国证券业协会', year: '2021', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: '中金公司（中国国际金融股份有限公司）',
        title: '高级金融分析师',
        startYear: '2022',
        endYear: '',
        current: true,
        description: '负责A股及港股市场研究报告撰写，覆盖消费、科技板块，服务机构客户资产规模超50亿元。',
        verified: true,
      },
      {
        company: '平安证券',
        title: '金融分析师',
        startYear: '2020',
        endYear: '2022',
        current: false,
        description: '参与IPO项目尽职调查，协助完成3个上市项目，累计融资规模逾20亿元。',
        verified: true,
      },
    ],
  },
  {
    id: 2,
    name: '志远',
    age: 32,
    location: '北京',
    locationEn: 'Beijing',
    flag: '🇨🇳',
    education: '博士 · 计算机科学',
    school: '清华大学',
    major: '计算机科学与技术',
    gradYear: '2019',
    match: 94,
    height: '178cm',
    weight: '72kg',
    zodiac: '摩羯座',
    job: '高级算法工程师',
    income: '50-80万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '理工男，内心温柔，喜欢户外运动和烹饪，期待遇见温暖的她。我认为婚姻是两个人共同经营的事业，需要双方都有良好的教育背景和相似的人生目标。',
    interests: ['编程', '登山', '烹饪', '电影', '健身'],
    languages: ['普通话', '英语', '日语'],
    lookingFor: '希望找到独立自主、有自己事业的女性，学历硕士以上',
    avatar: 'https://readdy.ai/api/search-image?query=handsome%20Chinese%20man%20professional%20portrait%2C%20confident%20smile%2C%20clean%20background%2C%20soft%20lighting%2C%20high%20quality%20photography%2C%20age%2032%2C%20intellectual%20appearance&width=400&height=400&seq=mem002&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=Chinese%20man%20hiking%20mountain%20trail%2C%20outdoor%20adventure%2C%20confident%20expression%2C%20natural%20scenery%2C%20age%2032&width=600&height=400&seq=mem002p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20man%20cooking%20gourmet%20meal%20in%20modern%20kitchen%2C%20focused%20expression%2C%20warm%20lighting%2C%20lifestyle%20photography%2C%20age%2032&width=600&height=400&seq=mem002p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20man%20working%20on%20laptop%20in%20modern%20office%2C%20professional%20setting%2C%20focused%2C%20age%2032&width=600&height=400&seq=mem002p3&orientation=landscape',
    ],
    credentials: [
      { type: '博士学位证书', institution: '清华大学计算机系', year: '2019', verified: true },
      { type: '身份证实名认证', institution: '国家公安系统', year: '2024', verified: true },
      { type: '国家发明专利（3项）', institution: '国家知识产权局', year: '2023', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: '字节跳动（ByteDance）',
        title: '高级算法工程师 / Tech Lead',
        startYear: '2021',
        endYear: '',
        current: true,
        description: '主导推荐系统核心算法研发，带领8人团队，算法优化使DAU提升12%，获公司年度技术创新奖。',
        verified: true,
      },
      {
        company: '百度（Baidu）',
        title: '算法工程师',
        startYear: '2019',
        endYear: '2021',
        current: false,
        description: '参与自然语言处理项目，负责文本分类模型优化，准确率提升至97.3%。',
        verified: true,
      },
    ],
  },
  {
    id: 3,
    name: '晓雪',
    age: 26,
    location: '香港',
    locationEn: 'Hong Kong',
    flag: '🇭🇰',
    education: '本科 · 临床医学',
    school: '中山大学',
    major: '临床医学',
    gradYear: '2022',
    match: 91,
    height: '162cm',
    weight: '48kg',
    zodiac: '双鱼座',
    job: '住院医师',
    income: '20-30万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '从事医疗行业，善良体贴，希望找到成熟稳重的另一半。医生这份职业让我更加珍惜生命中的每一刻，我希望找到一个能够理解我工作性质、共同建立温暖家庭的伴侣。',
    interests: ['医学研究', '瑜伽', '烘焙', '旅行', '公益'],
    languages: ['普通话', '粤语', '英语'],
    lookingFor: '寻找成熟稳重、有责任心的男性，能够理解医生工作的特殊性',
    avatar: 'https://readdy.ai/api/search-image?query=gentle%20Chinese%20woman%20doctor%20portrait%2C%20kind%20smile%2C%20professional%20appearance%2C%20soft%20warm%20lighting%2C%20clean%20background%2C%20high%20quality%20photography%2C%20age%2026&width=400&height=400&seq=mem003&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=Chinese%20woman%20doctor%20in%20hospital%20corridor%2C%20professional%20white%20coat%2C%20warm%20smile%2C%20soft%20lighting%2C%20age%2026&width=600&height=400&seq=mem003p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20woman%20doing%20yoga%20in%20bright%20studio%2C%20peaceful%20expression%2C%20natural%20lighting%2C%20lifestyle%20photography%2C%20age%2026&width=600&height=400&seq=mem003p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20woman%20baking%20in%20kitchen%2C%20flour%20on%20hands%2C%20happy%20laughing%20expression%2C%20warm%20home%20atmosphere%2C%20age%2026&width=600&height=400&seq=mem003p3&orientation=landscape',
    ],
    credentials: [
      { type: '临床医学学士学位', institution: '中山大学医学院', year: '2022', verified: true },
      { type: '执业医师资格证', institution: '国家卫生健康委员会', year: '2023', verified: true },
      { type: '身份证实名认证', institution: '国家公安系统', year: '2024', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: '中山大学附属第一医院',
        title: '住院医师（内科）',
        startYear: '2022',
        endYear: '',
        current: true,
        description: '完成规范化培训，独立负责内科病房日常诊疗工作，参与多项临床研究课题，发表SCI论文1篇。',
        verified: true,
      },
    ],
  },
  {
    id: 4,
    name: '建国',
    age: 30,
    location: '新加坡',
    locationEn: 'Singapore',
    flag: '🇸🇬',
    education: '硕士 · 工商管理',
    school: '北京大学',
    major: 'MBA（工商管理）',
    gradYear: '2018',
    match: 89,
    height: '175cm',
    weight: '70kg',
    zodiac: '狮子座',
    job: '创始人 / CEO',
    income: '50-100万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '创业中，有梦想有担当，希望找到一起奋斗的伴侣。我创立了一家科技公司，相信努力和教育是改变命运的关键。希望找到同样有追求、有梦想的另一半。',
    interests: ['创业', '投资', '高尔夫', '读书', '旅行'],
    languages: ['普通话', '英语', '粤语'],
    lookingFor: '希望找到有独立思想、有事业心的女性，共同创造美好未来',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20entrepreneur%20man%20portrait%2C%20confident%20expression%2C%20modern%20style%2C%20clean%20background%2C%20professional%20photography%2C%20age%2030%2C%20ambitious%20look&width=400&height=400&seq=mem004&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=Chinese%20entrepreneur%20man%20in%20modern%20office%20giving%20presentation%2C%20confident%2C%20professional%20setting%2C%20age%2030&width=600&height=400&seq=mem004p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20man%20playing%20golf%20on%20green%20course%2C%20sunny%20day%2C%20casual%20elegant%20style%2C%20age%2030&width=600&height=400&seq=mem004p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20man%20reading%20business%20book%20in%20modern%20cafe%2C%20focused%2C%20stylish%2C%20age%2030&width=600&height=400&seq=mem004p3&orientation=landscape',
    ],
    credentials: [
      { type: 'MBA学位证书', institution: '北京大学光华管理学院', year: '2018', verified: true },
      { type: '营业执照（法定代表人）', institution: '深圳市市场监督管理局', year: '2020', verified: true },
      { type: '身份证实名认证', institution: '国家公安系统', year: '2024', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: '深圳星辰科技有限公司',
        title: '创始人 / CEO',
        startYear: '2020',
        endYear: '',
        current: true,
        description: '创立AI+教育科技公司，累计融资3000万元（天使轮+Pre-A轮），团队规模45人，服务学校超200所。',
        verified: true,
      },
      {
        company: '腾讯（Tencent）',
        title: '产品经理',
        startYear: '2018',
        endYear: '2020',
        current: false,
        description: '负责微信教育类小程序产品规划，月活用户从0增长至80万，获腾讯年度优秀产品奖。',
        verified: true,
      },
    ],
  },
  {
    id: 5,
    name: '美琳',
    age: 29,
    location: '悉尼',
    locationEn: 'Sydney',
    flag: '🇦🇺',
    education: '本科 · 视觉传达设计',
    school: '中国美术学院',
    major: '视觉传达设计',
    gradYear: '2018',
    match: 88,
    height: '168cm',
    weight: '52kg',
    zodiac: '射手座',
    job: '创意总监',
    income: '20-30万/年',
    verified: true,
    videoVerified: false,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '热爱艺术与设计，生活充满色彩，寻找懂我的那个人。我用设计表达对生活的热爱，希望找到一个欣赏艺术、有品位的另一半，一起创造美好的生活。',
    interests: ['设计', '绘画', '摄影', '音乐', '展览'],
    languages: ['普通话', '英语', '法语'],
    lookingFor: '寻找有艺术品位、懂得欣赏美的另一半，重视精神层面的交流',
    avatar: 'https://readdy.ai/api/search-image?query=creative%20Chinese%20woman%20artist%20portrait%2C%20artistic%20style%2C%20warm%20smile%2C%20soft%20background%2C%20high%20quality%20photography%2C%20age%2029%2C%20elegant%20appearance&width=400&height=400&seq=mem005&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=Chinese%20woman%20artist%20painting%20in%20bright%20studio%2C%20creative%20atmosphere%2C%20colorful%20surroundings%2C%20age%2029&width=600&height=400&seq=mem005p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20woman%20photographer%20taking%20photos%20in%20city%20street%2C%20artistic%20style%2C%20natural%20light%2C%20age%2029&width=600&height=400&seq=mem005p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20woman%20at%20art%20gallery%20exhibition%2C%20elegant%20dress%2C%20appreciating%20artwork%2C%20age%2029&width=600&height=400&seq=mem005p3&orientation=landscape',
    ],
    credentials: [
      { type: '视觉传达设计学士学位', institution: '中国美术学院', year: '2018', verified: true },
      { type: '身份证实名认证', institution: '国家公安系统', year: '2024', verified: true },
      { type: '国家一级美术师资格', institution: '中国美术家协会', year: '2022', verified: true },
    ],
    workExperience: [
      {
        company: '网易（NetEase）游戏事业部',
        title: '创意总监',
        startYear: '2022',
        endYear: '',
        current: true,
        description: '主导多款游戏UI/UX视觉体系设计，带领12人设计团队，作品获2023年中国游戏设计金奖。',
        verified: true,
      },
      {
        company: '阿里巴巴集团 · 淘宝',
        title: '高级视觉设计师',
        startYear: '2018',
        endYear: '2022',
        current: false,
        description: '负责淘宝双11大促视觉设计，参与品牌升级项目，设计作品曝光量累计超10亿次。',
        verified: true,
      },
    ],
  },
  {
    id: 6,
    name: '浩然',
    age: 34,
    location: '纽约',
    locationEn: 'New York',
    flag: '🇺🇸',
    education: '博士 · 法学',
    school: '四川大学',
    major: '民商法学',
    gradYear: '2017',
    match: 87,
    height: '180cm',
    weight: '75kg',
    zodiac: '金牛座',
    job: '合伙人律师',
    income: '50-80万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '法律从业者，严谨认真，生活中却是个有趣的人，期待遇见你。我相信法律和教育是社会进步的基石，在工作之余我喜欢品茶、下棋，享受生活的慢节奏。',
    interests: ['法律研究', '品茶', '围棋', '古典音乐', '历史'],
    languages: ['普通话', '英语', '四川话'],
    lookingFor: '希望找到温柔贤淑、有内涵的女性，重视家庭和传统价值观',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20lawyer%20man%20portrait%2C%20serious%20yet%20warm%20expression%2C%20suit%2C%20clean%20background%2C%20high%20quality%20photography%2C%20age%2034%2C%20trustworthy%20appearance&width=400&height=400&seq=mem006&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=Chinese%20lawyer%20man%20in%20courtroom%20professional%20setting%2C%20confident%20posture%2C%20formal%20suit%2C%20age%2034&width=600&height=400&seq=mem006p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20man%20doing%20traditional%20tea%20ceremony%2C%20peaceful%20atmosphere%2C%20elegant%20setting%2C%20age%2034&width=600&height=400&seq=mem006p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20man%20playing%20chess%20in%20traditional%20teahouse%2C%20focused%20expression%2C%20warm%20lighting%2C%20age%2034&width=600&height=400&seq=mem006p3&orientation=landscape',
    ],
    credentials: [
      { type: '法学博士学位', institution: '四川大学法学院', year: '2017', verified: true },
      { type: '律师执业证', institution: '四川省司法厅', year: '2018', verified: true },
      { type: '身份证实名认证', institution: '国家公安系统', year: '2024', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: '君合律师事务所（成都办公室）',
        title: '合伙人律师',
        startYear: '2021',
        endYear: '',
        current: true,
        description: '专注于公司并购、资本市场及争议解决领域，代理案件标的额累计超30亿元，连续3年获"成都十佳律师"称号。',
        verified: true,
      },
      {
        company: '金杜律师事务所',
        title: '律师',
        startYear: '2017',
        endYear: '2021',
        current: false,
        description: '参与多起跨境并购及上市项目，协助完成境外融资项目5个，积累丰富的国际商事法律经验。',
        verified: true,
      },
    ],
  },
  {
    id: 7,
    name: 'Lucas',
    age: 27,
    location: '伦敦',
    locationEn: 'London',
    flag: '🇬🇧',
    education: '硕士 · 国际商务',
    school: 'London School of Economics',
    major: '国际商务',
    gradYear: '2021',
    match: 93,
    height: '185cm',
    weight: '78kg',
    zodiac: '双子座',
    job: '投资银行分析师',
    income: '60-90万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '来自英国的阳光男孩，金色头发，热爱中国文化和美食。在伦敦金融城工作，业余时间学习普通话，希望找到一位聪明美丽的东方女性共度一生。',
    interests: ['金融', '旅行', '中国文化', '网球', '美食'],
    languages: ['英语', '普通话（学习中）', '法语'],
    lookingFor: '希望找到温柔聪慧、有文化底蕴的东方女性，共同探索世界',
    avatar: 'https://readdy.ai/api/search-image?query=extremely%20handsome%20young%20British%20man%20with%20beautiful%20golden%20blonde%20hair%2C%20bright%20blue%20eyes%2C%20charming%20warm%20smile%2C%20professional%20portrait%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20age%2027%2C%20attractive%20masculine%20features%2C%20well-groomed&width=400&height=400&seq=mem007&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=handsome%20blonde%20young%20man%20in%20London%20city%20financial%20district%2C%20stylish%20suit%2C%20confident%20smile%2C%20urban%20background%2C%20age%2027&width=600&height=400&seq=mem007p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=attractive%20blonde%20man%20playing%20tennis%20on%20court%2C%20athletic%20build%2C%20sunny%20day%2C%20sporty%20style%2C%20age%2027&width=600&height=400&seq=mem007p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=handsome%20blonde%20man%20enjoying%20Chinese%20food%20in%20elegant%20restaurant%2C%20happy%20expression%2C%20casual%20style%2C%20age%2027&width=600&height=400&seq=mem007p3&orientation=landscape',
    ],
    credentials: [
      { type: 'MSc International Business', institution: 'London School of Economics', year: '2021', verified: true },
      { type: 'Passport Identity Verification', institution: 'UK Home Office', year: '2024', verified: true },
      { type: 'CFA Level II', institution: 'CFA Institute', year: '2023', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: 'Goldman Sachs London',
        title: 'Investment Banking Analyst',
        startYear: '2021',
        endYear: '',
        current: true,
        description: 'Specializing in Asia-Pacific M&A transactions, managing deal flow exceeding £500M annually, with strong focus on cross-border China deals.',
        verified: true,
      },
    ],
  },
  {
    id: 8,
    name: '诗涵',
    age: 25,
    location: '东京',
    locationEn: 'Tokyo',
    flag: '🇯🇵',
    education: '本科 · 日语文学',
    school: '早稻田大学',
    major: '日语文学',
    gradYear: '2023',
    match: 92,
    height: '160cm',
    weight: '46kg',
    zodiac: '处女座',
    job: '时尚编辑',
    income: '15-25万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: false,
    bio: '在东京从事时尚媒体工作，喜欢日式美学和精致生活。外表清秀，内心丰富，希望找到一位成熟有担当的另一半，一起在异国他乡建立温暖的家。',
    interests: ['时尚', '日式美食', '茶道', '摄影', '文学'],
    languages: ['普通话', '日语', '英语'],
    lookingFor: '寻找成熟稳重、有国际视野的男性，能够理解异乡生活的不易',
    avatar: 'https://readdy.ai/api/search-image?query=stunning%20beautiful%20young%20Chinese%20woman%20with%20delicate%20elegant%20features%2C%20flawless%20porcelain%20skin%2C%20graceful%20smile%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20high%20quality%20portrait%20photography%2C%20age%2025%2C%20refined%20feminine%20beauty&width=400&height=400&seq=mem008&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20woman%20in%20Tokyo%20Shibuya%20street%2C%20fashionable%20outfit%2C%20cherry%20blossom%20background%2C%20elegant%20style%2C%20age%2025&width=600&height=400&seq=mem008p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=elegant%20Chinese%20woman%20doing%20Japanese%20tea%20ceremony%2C%20kimono%2C%20peaceful%20atmosphere%2C%20soft%20lighting%2C%20age%2025&width=600&height=400&seq=mem008p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20woman%20at%20fashion%20magazine%20editorial%20shoot%2C%20stylish%2C%20professional%20photography%2C%20age%2025&width=600&height=400&seq=mem008p3&orientation=landscape',
    ],
    credentials: [
      { type: '日语文学学士学位', institution: '早稻田大学', year: '2023', verified: true },
      { type: '日语能力测试 N1', institution: '国际交流基金', year: '2022', verified: true },
      { type: '身份证实名认证', institution: '国家公安系统', year: '2024', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: 'VOGUE Japan 中文版',
        title: '时尚编辑助理',
        startYear: '2023',
        endYear: '',
        current: true,
        description: '负责时尚专题策划与撰写，参与多次国际时装周报道，作品发表于VOGUE官网及社交媒体。',
        verified: false,
      },
    ],
  },
  {
    id: 9,
    name: 'Ethan',
    age: 29,
    location: '悉尼',
    locationEn: 'Sydney',
    flag: '🇦🇺',
    education: '硕士 · 建筑设计',
    school: 'University of Sydney',
    major: '建筑设计',
    gradYear: '2020',
    match: 90,
    height: '183cm',
    weight: '80kg',
    zodiac: '白羊座',
    job: '建筑师',
    income: '40-60万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '澳大利亚建筑师，一头亮丽金发，热爱冲浪和户外生活。对中国文化充满好奇，曾多次来华旅行，希望找到一位美丽善良的中国女性，共同创造美好生活。',
    interests: ['建筑设计', '冲浪', '旅行', '摄影', '烹饪'],
    languages: ['英语', '普通话（基础）'],
    lookingFor: '希望找到开朗活泼、热爱生活的女性，一起探索世界的美好',
    avatar: 'https://readdy.ai/api/search-image?query=gorgeous%20handsome%20young%20Australian%20man%20with%20stunning%20golden%20blonde%20hair%2C%20athletic%20tanned%20skin%2C%20bright%20green%20eyes%2C%20dazzling%20smile%2C%20professional%20portrait%2C%20clean%20background%2C%20soft%20natural%20lighting%2C%20age%2029%2C%20very%20attractive%20masculine%20appearance&width=400&height=400&seq=mem009&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=handsome%20blonde%20Australian%20man%20surfing%20on%20ocean%20waves%2C%20athletic%20body%2C%20sunny%20beach%2C%20action%20photography%2C%20age%2029&width=600&height=400&seq=mem009p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=attractive%20blonde%20man%20at%20architecture%20studio%20reviewing%20blueprints%2C%20professional%20setting%2C%20creative%20workspace%2C%20age%2029&width=600&height=400&seq=mem009p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=handsome%20blonde%20man%20hiking%20in%20Australian%20national%20park%2C%20outdoor%20adventure%2C%20natural%20scenery%2C%20age%2029&width=600&height=400&seq=mem009p3&orientation=landscape',
    ],
    credentials: [
      { type: 'Master of Architecture', institution: 'University of Sydney', year: '2020', verified: true },
      { type: 'Registered Architect', institution: 'Architects Accreditation Council of Australia', year: '2021', verified: true },
      { type: 'Passport Identity Verification', institution: 'Australian Government', year: '2024', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: 'Cox Architecture Sydney',
        title: 'Senior Architect',
        startYear: '2021',
        endYear: '',
        current: true,
        description: 'Leading design of landmark commercial and residential projects across Sydney and Melbourne, with portfolio value exceeding AUD $200M.',
        verified: true,
      },
    ],
  },
  {
    id: 10,
    name: '若曦',
    age: 31,
    location: '上海',
    locationEn: 'Shanghai',
    flag: '🇨🇳',
    education: '硕士 · 心理学',
    school: '北京师范大学',
    major: '应用心理学',
    gradYear: '2017',
    match: 95,
    height: '167cm',
    weight: '53kg',
    zodiac: '天蝎座',
    job: '心理咨询师',
    income: '25-40万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '心理咨询师，善于倾听，内心温暖而坚定。我相信每段感情都需要用心经营，希望找到一位真诚、有深度的另一半，共同建立充满爱与理解的家庭。',
    interests: ['心理学', '冥想', '阅读', '瑜伽', '旅行'],
    languages: ['普通话', '英语'],
    lookingFor: '寻找情感成熟、有自我认知的男性，重视心灵的契合与深度交流',
    avatar: 'https://readdy.ai/api/search-image?query=beautiful%20sophisticated%20Chinese%20woman%20with%20warm%20intelligent%20eyes%2C%20gentle%20confident%20smile%2C%20elegant%20professional%20portrait%2C%20soft%20warm%20lighting%2C%20clean%20background%2C%20high%20quality%20photography%2C%20age%2031%2C%20graceful%20mature%20beauty&width=400&height=400&seq=mem010&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20woman%20psychologist%20in%20cozy%20counseling%20office%2C%20warm%20professional%20setting%2C%20gentle%20expression%2C%20age%2031&width=600&height=400&seq=mem010p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=elegant%20Chinese%20woman%20meditating%20in%20peaceful%20garden%2C%20serene%20atmosphere%2C%20soft%20morning%20light%2C%20age%2031&width=600&height=400&seq=mem010p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20woman%20reading%20book%20in%20cozy%20library%2C%20warm%20lighting%2C%20intellectual%20atmosphere%2C%20age%2031&width=600&height=400&seq=mem010p3&orientation=landscape',
    ],
    credentials: [
      { type: '应用心理学硕士学位', institution: '北京师范大学', year: '2017', verified: true },
      { type: '国家二级心理咨询师', institution: '人力资源和社会保障部', year: '2018', verified: true },
      { type: '身份证实名认证', institution: '国家公安系统', year: '2024', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: '上海心灵港湾心理咨询中心',
        title: '首席心理咨询师',
        startYear: '2019',
        endYear: '',
        current: true,
        description: '累计服务来访者超1200人次，专注婚恋情感、职场压力及个人成长领域，好评率98.6%。',
        verified: true,
      },
    ],
  },
  {
    id: 11,
    name: 'Noah',
    age: 26,
    location: '多伦多',
    locationEn: 'Toronto',
    flag: '🇨🇦',
    education: '本科 · 计算机科学',
    school: 'University of Toronto',
    major: '计算机科学',
    gradYear: '2022',
    match: 88,
    height: '181cm',
    weight: '76kg',
    zodiac: '巨蟹座',
    job: '软件工程师',
    income: '35-55万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '加拿大阳光男孩，浅金色头发，性格温柔体贴。在科技公司工作，业余时间喜欢打篮球和学习中文。对中国文化非常感兴趣，希望找到一位美丽善良的中国女孩。',
    interests: ['编程', '篮球', '中文学习', '电影', '旅行'],
    languages: ['英语', '法语', '普通话（学习中）'],
    lookingFor: '希望找到温柔善良、有爱心的女性，一起建立跨文化的美好家庭',
    avatar: 'https://readdy.ai/api/search-image?query=very%20handsome%20young%20Canadian%20man%20with%20light%20golden%20blonde%20hair%2C%20warm%20hazel%20eyes%2C%20sweet%20gentle%20smile%2C%20professional%20portrait%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20age%2026%2C%20boyish%20charming%20attractive%20appearance%2C%20well-groomed&width=400&height=400&seq=mem011&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=handsome%20blonde%20young%20man%20playing%20basketball%20outdoors%2C%20athletic%2C%20energetic%2C%20sunny%20day%2C%20age%2026&width=600&height=400&seq=mem011p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=attractive%20blonde%20man%20working%20on%20laptop%20in%20modern%20tech%20office%2C%20casual%20smart%20style%2C%20focused%2C%20age%2026&width=600&height=400&seq=mem011p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=handsome%20blonde%20man%20studying%20Chinese%20language%20with%20books%2C%20curious%20expression%2C%20cozy%20cafe%2C%20age%2026&width=600&height=400&seq=mem011p3&orientation=landscape',
    ],
    credentials: [
      { type: 'BSc Computer Science', institution: 'University of Toronto', year: '2022', verified: true },
      { type: 'AWS Certified Solutions Architect', institution: 'Amazon Web Services', year: '2023', verified: true },
      { type: 'Passport Identity Verification', institution: 'Government of Canada', year: '2024', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: 'Shopify Inc.',
        title: 'Software Engineer',
        startYear: '2022',
        endYear: '',
        current: true,
        description: 'Building scalable e-commerce infrastructure serving 2M+ merchants globally, specializing in payment systems and API development.',
        verified: true,
      },
    ],
  },
  {
    id: 12,
    name: '嘉怡',
    age: 27,
    location: '广州',
    locationEn: 'Guangzhou',
    flag: '🇨🇳',
    education: '本科 · 国际贸易',
    school: '中山大学',
    major: '国际贸易',
    gradYear: '2020',
    match: 91,
    height: '163cm',
    weight: '49kg',
    zodiac: '水瓶座',
    job: '外贸经理',
    income: '20-35万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '广州女孩，活泼开朗，笑容甜美。从事外贸行业，经常出差海外，见多识广。喜欢美食和旅行，希望找到一位有趣有担当的另一半，一起享受生活的美好。',
    interests: ['美食', '旅行', '粤语歌', '瑜伽', '购物'],
    languages: ['普通话', '粤语', '英语'],
    lookingFor: '寻找幽默风趣、有上进心的男性，能够接受我经常出差的工作性质',
    avatar: 'https://readdy.ai/api/search-image?query=gorgeous%20beautiful%20young%20Chinese%20Cantonese%20woman%2C%20bright%20sparkling%20eyes%2C%20sweet%20charming%20smile%2C%20flawless%20skin%2C%20professional%20portrait%2C%20soft%20warm%20lighting%2C%20clean%20background%2C%20high%20quality%20photography%2C%20age%2027%2C%20vibrant%20youthful%20beauty&width=400&height=400&seq=mem012&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20woman%20at%20Guangzhou%20Canton%20Fair%20trade%20show%2C%20professional%20business%20setting%2C%20confident%20smile%2C%20age%2027&width=600&height=400&seq=mem012p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=pretty%20Chinese%20woman%20enjoying%20dim%20sum%20breakfast%20in%20traditional%20Guangzhou%20teahouse%2C%20happy%20expression%2C%20age%2027&width=600&height=400&seq=mem012p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20woman%20traveling%20in%20European%20city%2C%20fashionable%20outfit%2C%20happy%20tourist%2C%20age%2027&width=600&height=400&seq=mem012p3&orientation=landscape',
    ],
    credentials: [
      { type: '国际贸易学士学位', institution: '中山大学', year: '2020', verified: true },
      { type: '报关员资格证书', institution: '海关总署', year: '2021', verified: true },
      { type: '身份证实名认证', institution: '国家公安系统', year: '2024', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: '广州华贸国际贸易有限公司',
        title: '外贸经理',
        startYear: '2021',
        endYear: '',
        current: true,
        description: '负责欧美市场开发与维护，年均出口额超2000万美元，客户满意度连续3年达100%。',
        verified: true,
      },
    ],
  },
  {
    id: 13,
    name: '俊杰',
    age: 33,
    location: '迪拜',
    locationEn: 'Dubai',
    flag: '🇦🇪',
    education: '硕士 · 土木工程',
    school: '同济大学',
    major: '土木工程',
    gradYear: '2016',
    match: 86,
    height: '177cm',
    weight: '73kg',
    zodiac: '天秤座',
    job: '项目总监',
    income: '60-100万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '在迪拜从事大型基建项目管理，见证了这座城市的飞速发展。工作认真负责，生活中喜欢健身和美食。希望找到一位温柔体贴、有家庭观念的女性，共同建立幸福家庭。',
    interests: ['健身', '美食', '旅行', '投资', '足球'],
    languages: ['普通话', '英语', '阿拉伯语（基础）'],
    lookingFor: '希望找到有家庭观念、温柔贤惠的女性，愿意在海外共同生活',
    avatar: 'https://readdy.ai/api/search-image?query=very%20handsome%20mature%20Chinese%20man%2C%20strong%20masculine%20features%2C%20confident%20charming%20smile%2C%20well-groomed%2C%20professional%20portrait%2C%20clean%20background%2C%20soft%20lighting%2C%20age%2033%2C%20successful%20attractive%20appearance&width=400&height=400&seq=mem013&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=handsome%20Chinese%20man%20at%20Dubai%20construction%20site%20with%20city%20skyline%20background%2C%20professional%20hard%20hat%2C%20confident%2C%20age%2033&width=600&height=400&seq=mem013p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20man%20working%20out%20in%20modern%20gym%2C%20athletic%20build%2C%20focused%20expression%2C%20age%2033&width=600&height=400&seq=mem013p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=handsome%20Chinese%20man%20dining%20at%20luxury%20Dubai%20restaurant%2C%20elegant%20setting%2C%20relaxed%20smile%2C%20age%2033&width=600&height=400&seq=mem013p3&orientation=landscape',
    ],
    credentials: [
      { type: '土木工程硕士学位', institution: '同济大学', year: '2016', verified: true },
      { type: '一级建造师资格证', institution: '住房和城乡建设部', year: '2018', verified: true },
      { type: '身份证实名认证', institution: '国家公安系统', year: '2024', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: 'CSCEC Middle East (中建中东)',
        title: '项目总监',
        startYear: '2019',
        endYear: '',
        current: true,
        description: '主管迪拜多个大型商业综合体建设项目，总投资额超15亿迪拉姆，团队规模200余人。',
        verified: true,
      },
    ],
  },
  {
    id: 14,
    name: '芷晴',
    age: 24,
    location: '巴黎',
    locationEn: 'Paris',
    flag: '🇫🇷',
    education: '本科 · 时装设计',
    school: 'École de la Chambre Syndicale de la Couture Parisienne',
    major: '高级时装设计',
    gradYear: '2023',
    match: 94,
    height: '169cm',
    weight: '51kg',
    zodiac: '双子座',
    job: '时装设计师',
    income: '15-25万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: false,
    bio: '在巴黎学习高级时装设计，热爱艺术与美学。外表清丽脱俗，内心充满创意与热情。希望找到一位有品位、有内涵的另一半，在浪漫的巴黎共同书写爱情故事。',
    interests: ['时装设计', '艺术', '法语', '美食', '博物馆'],
    languages: ['普通话', '法语', '英语'],
    lookingFor: '寻找有艺术气质、懂得欣赏美的另一半，重视精神层面的共鸣',
    avatar: 'https://readdy.ai/api/search-image?query=breathtakingly%20beautiful%20young%20Chinese%20woman%20with%20exquisite%20delicate%20features%2C%20luminous%20flawless%20skin%2C%20elegant%20graceful%20smile%2C%20soft%20romantic%20lighting%2C%20clean%20background%2C%20high%20fashion%20portrait%20photography%2C%20age%2024%2C%20ethereal%20feminine%20beauty&width=400&height=400&seq=mem014&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20woman%20fashion%20designer%20in%20Paris%20atelier%2C%20elegant%20dress%2C%20creative%20workspace%2C%20soft%20lighting%2C%20age%2024&width=600&height=400&seq=mem014p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=stunning%20Chinese%20woman%20at%20Eiffel%20Tower%20Paris%2C%20fashionable%20outfit%2C%20romantic%20atmosphere%2C%20golden%20hour%20light%2C%20age%2024&width=600&height=400&seq=mem014p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20woman%20at%20Louvre%20museum%20Paris%2C%20elegant%20style%2C%20appreciating%20art%2C%20soft%20lighting%2C%20age%2024&width=600&height=400&seq=mem014p3&orientation=landscape',
    ],
    credentials: [
      { type: 'Diplôme de Stylisme', institution: 'École de la Chambre Syndicale', year: '2023', verified: true },
      { type: '身份证实名认证', institution: '国家公安系统', year: '2024', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: 'Maison Valentino Paris',
        title: '设计助理',
        startYear: '2023',
        endYear: '',
        current: true,
        description: '参与2024春夏系列设计工作，负责面料研究与样衣制作，作品入选巴黎时装周展示。',
        verified: false,
      },
    ],
  },
  {
    id: 15,
    name: '明轩',
    age: 35,
    location: '香港',
    locationEn: 'Hong Kong',
    flag: '🇭🇰',
    education: '博士 · 金融学',
    school: '香港大学',
    major: '金融学',
    gradYear: '2015',
    match: 89,
    height: '176cm',
    weight: '71kg',
    zodiac: '摩羯座',
    job: '基金经理',
    income: '100万+/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '香港金融精英，低调务实，有责任心。工作之余喜欢打高尔夫和品红酒，享受精致生活。希望找到一位温柔大方、有气质的女性，共同经营幸福的家庭。',
    interests: ['金融投资', '高尔夫', '红酒', '旅行', '古典音乐'],
    languages: ['粤语', '普通话', '英语'],
    lookingFor: '希望找到温柔大方、有家庭观念的女性，学历本科以上，有自己的事业',
    avatar: 'https://readdy.ai/api/search-image?query=very%20handsome%20sophisticated%20Hong%20Kong%20Chinese%20man%2C%20sharp%20refined%20features%2C%20confident%20elegant%20smile%2C%20premium%20professional%20portrait%2C%20clean%20background%2C%20soft%20studio%20lighting%2C%20age%2035%2C%20distinguished%20successful%20appearance&width=400&height=400&seq=mem015&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=handsome%20Chinese%20man%20at%20Hong%20Kong%20financial%20district%20Victoria%20Harbour%20view%2C%20luxury%20suit%2C%20confident%2C%20age%2035&width=600&height=400&seq=mem015p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=elegant%20Chinese%20man%20playing%20golf%20on%20scenic%20course%2C%20casual%20luxury%20style%2C%20sunny%20day%2C%20age%2035&width=600&height=400&seq=mem015p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=sophisticated%20Chinese%20man%20wine%20tasting%20at%20upscale%20restaurant%2C%20refined%20expression%2C%20elegant%20setting%2C%20age%2035&width=600&height=400&seq=mem015p3&orientation=landscape',
    ],
    credentials: [
      { type: '金融学博士学位', institution: '香港大学', year: '2015', verified: true },
      { type: 'CFA特许金融分析师', institution: 'CFA Institute', year: '2016', verified: true },
      { type: '香港证券及期货从业员牌照', institution: '香港证监会', year: '2016', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: '摩根大通香港',
        title: '执行董事 / 基金经理',
        startYear: '2018',
        endYear: '',
        current: true,
        description: '管理亚太区股票基金规模超50亿港元，年均回报率18.6%，连续5年跑赢基准指数。',
        verified: true,
      },
    ],
  },
  {
    id: 16,
    name: '欣妍',
    age: 30,
    location: '新加坡',
    locationEn: 'Singapore',
    flag: '🇸🇬',
    education: '硕士 · 生物医学',
    school: '新加坡国立大学',
    major: '生物医学工程',
    gradYear: '2018',
    match: 93,
    height: '164cm',
    weight: '50kg',
    zodiac: '狮子座',
    job: '生物医学研究员',
    income: '30-50万/年',
    verified: true,
    videoVerified: true,
    idVerified: true,
    eduVerified: true,
    workVerified: true,
    bio: '在新加坡从事生物医学研究，聪明独立，热爱科学。外表温婉，内心坚韧。希望找到一位有智慧、有担当的另一半，共同在这座花园城市建立美好的家庭。',
    interests: ['科学研究', '瑜伽', '烹饪', '旅行', '读书'],
    languages: ['普通话', '英语', '粤语'],
    lookingFor: '寻找有智慧、有上进心的男性，能够欣赏独立女性的价值',
    avatar: 'https://readdy.ai/api/search-image?query=beautiful%20intelligent%20Chinese%20Singaporean%20woman%2C%20bright%20expressive%20eyes%2C%20warm%20confident%20smile%2C%20professional%20portrait%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20high%20quality%20photography%2C%20age%2030%2C%20elegant%20smart%20appearance&width=400&height=400&seq=mem016&orientation=squarish',
    photos: [
      'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20woman%20scientist%20in%20biomedical%20laboratory%20Singapore%2C%20professional%20white%20coat%2C%20focused%20expression%2C%20age%2030&width=600&height=400&seq=mem016p1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=elegant%20Chinese%20woman%20doing%20yoga%20in%20Singapore%20Gardens%20by%20the%20Bay%2C%20peaceful%20atmosphere%2C%20sunrise%2C%20age%2030&width=600&height=400&seq=mem016p2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20woman%20cooking%20healthy%20meal%20in%20modern%20Singapore%20apartment%2C%20happy%20expression%2C%20age%2030&width=600&height=400&seq=mem016p3&orientation=landscape',
    ],
    credentials: [
      { type: '生物医学工程硕士学位', institution: '新加坡国立大学', year: '2018', verified: true },
      { type: '新加坡注册研究员', institution: 'A*STAR Singapore', year: '2019', verified: true },
      { type: '身份证实名认证', institution: '国家公安系统', year: '2024', verified: true },
      { type: '视频身份认证', institution: '富缘佳旺平台', year: '2024', verified: true },
    ],
    workExperience: [
      {
        company: 'A*STAR Biomedical Research Institute',
        title: 'Senior Research Scientist',
        startYear: '2020',
        endYear: '',
        current: true,
        description: '主导癌症早期诊断生物标志物研究项目，发表SCI论文8篇，累计引用次数超300次，获新加坡国家科研奖。',
        verified: true,
      },
    ],
  },
];

export type Member = typeof featuredMembers[0];
